import { ELEMENT_PARAGRAPH } from '@udecode/plate';
const trailingBlockPlugin = {
    options: { type: ELEMENT_PARAGRAPH },
};
export default trailingBlockPlugin;
//# sourceMappingURL=trailingBlockPlugin.js.map